import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DisplayPdfFrameService {
  private Rush$ = new BehaviorSubject<MouseEvent | null>(null);
  selectedRush$ = this.Rush$.asObservable();

  private Revised$ = new BehaviorSubject<MouseEvent | null>(null);
  selectedRevised$ = this.Revised$.asObservable();

  private templates$ = new BehaviorSubject<number | null>(null);
  selectedtemplates$ = this.templates$.asObservable();

  private poNumber$ = new BehaviorSubject<string>("");
  selectedpoNumber$ = this.poNumber$.asObservable();

  onRushSelection(event: MouseEvent) {
    this.Rush$.next(event);
  }

  onRevisedSelection(event: MouseEvent) {
    this.Revised$.next(event);
  }

  onTemplatesSelection(event: number) {
    this.templates$.next(event);
  }

  onPONumberSelection(event: string) {
    this.poNumber$.next(event);
  }
}
